import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import FormSection from 'dashboard/layouts/FormLayout/Section';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { isRequired, withMessage } from 'lib/utils/formValidation';

interface FormCreateTransactionTypeProps {
  handleClose: () => void;
}

const validate = {
  name: [withMessage('Please enter a name for this transaction type', isRequired)],
};

const FormCreateTransactionType = ({
  submitting,
  handleSubmit,
  handleClose,
}: FormCreateTransactionTypeProps &
  InjectedFormProps<FormCreateTransactionTypeData, FormCreateTransactionTypeProps>) => {
  return (
    <form onSubmit={handleSubmit}>
      <FormSection>
        <Field
          label='Name'
          name='name'
          id='name'
          disabled={submitting}
          type='text'
          component={InputField}
          data-test='add-transaction-type-form__name'
          validate={validate.name}
          autoFocus={true}
        />
      </FormSection>
      <HStack equal={true}>
        <Button
          variant='basic'
          id='add-transaction-type-form__cancel'
          data-test='add-transaction-type-form__cancel'
          disabled={submitting}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          id='add-transaction-type-form__confirm'
          data-test='add-transaction-type-form__confirm'
          disabled={submitting}
        >
          Create
        </Button>
      </HStack>
    </form>
  );
};

export interface FormCreateTransactionTypeData {
  name: string;
}

export default reduxForm<FormCreateTransactionTypeData, FormCreateTransactionTypeProps>({
  form: 'CreateTransactionType',
})(FormCreateTransactionType);
